export default {"src":"/pro/_next/static/media/inj.99b0d82a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};